import { createInstrumentedQueryClient } from "./otel-query-instrumentation";

export const queryClient = createInstrumentedQueryClient();
